import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import { COLORS_PROP_TYPE } from '@eb/eds-color';
import classnames from 'classnames';
import { Button } from '@eb/eds-button';
import Template from './_internal/Template';
import Image from './Image';
import {
    TEMPLATE_PROP_TYPES,
    TEMPLATE_PROPS,
} from '../constants/componentPropTypes';

import './twoColumnCTA.scss';

const CTAColumn = ({
    heading,
    description,
    CTAText,
    reverseHorizontal,
    isSmallScreen,
    onClick,
}) => {
    const textContainerClassName = classnames({
        'eds-g-offset-4-12': !reverseHorizontal && !isSmallScreen,
        'eds-g-cell-8-12': !isSmallScreen,
        'eds-g-cell-1-1': isSmallScreen,
    });
    const descriptionClassName = classnames(
        'eds-text-color--grey-600',
        'eds-text-bl',
        'eds-l-pad-vert-4',
        {
            'eds-l-mar-right-8': !isSmallScreen,
        },
    );

    return (
        <div className={textContainerClassName}>
            <h2 className="eds-text-hm eds-text-color--grey-900">{heading}</h2>
            <p className={descriptionClassName}>{description}</p>
            <div className="eds-l-pad-top-6">
                <Button style="fill" onClick={onClick}>
                    {CTAText}
                </Button>
            </div>
        </div>
    );
};

export default class TwoColumnCTA extends PureComponent {
    static propTypes = {
        ...TEMPLATE_PROP_TYPES,
        heading: translationPropType,
        description: translationPropType,
        CTAText: translationPropType,
        imageBackgroundColor: COLORS_PROP_TYPE,
        imagePath: PropTypes.string,
    };

    render() {
        const {
            heading,
            description,
            CTAText,
            imageBackgroundColor,
            imagePath,
            onClick,
            reverseHorizontal,
            hasImageOverflow,
        } = this.props;

        const templateProps = _.pick(this.props, TEMPLATE_PROPS);

        const imageSectionClassName = classnames(
            'eds-g-cell',
            'eds-g-cell-6-12',
            'eds-l-pad-vert-12',
            `eds-bg-color--${imageBackgroundColor}`,
            {
                'feature-image--overflow': hasImageOverflow,
            },
        );

        const imageContainerClassName = classnames({
            'feature-image--right__offset':
                hasImageOverflow && !reverseHorizontal,
            'feature-image--left__offset':
                hasImageOverflow && reverseHorizontal,
        });

        const textContainerClassName = classnames(
            'eds-g-cell',
            'eds-g-cell-6-12',
            {
                'eds-l-pad-left-12': reverseHorizontal,
            },
        );

        return (
            <div>
                <Template showOnlyLargeScreen={true} {...templateProps}>
                    <div className={imageSectionClassName}>
                        <div className={imageContainerClassName}>
                            <Image
                                imagePath={imagePath}
                                altDescription={heading}
                            />
                        </div>
                    </div>
                    <div className={textContainerClassName}>
                        <CTAColumn
                            heading={heading}
                            description={description}
                            CTAText={CTAText}
                            reverseHorizontal={reverseHorizontal}
                            onClick={onClick}
                        />
                    </div>
                </Template>
                <Template showOnlySmallScreen={true}>
                    <div
                        className={`eds-bg-color--${imageBackgroundColor} eds-l-pad-all-4 eds-align--center`}
                    >
                        <Image imagePath={imagePath} altDescription={heading} />
                    </div>
                    <div className="eds-l-pad-hor-8 eds-l-pad-vert-12">
                        <CTAColumn
                            heading={heading}
                            description={description}
                            CTAText={CTAText}
                            isSmallScreen={true}
                            onClick={onClick}
                        />
                    </div>
                </Template>
            </div>
        );
    }
}
